import { render, staticRenderFns } from "./dprForm.vue?vue&type=template&id=16323934&"
import script from "./dprForm.vue?vue&type=script&lang=js&"
export * from "./dprForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports